export const PageText = {
  _1: 'Automotive',
  _2: 'Make cars smart and healthy by automating A/C and providing your customers with the air quality info they need. See how aircheckr can boost your business!',
  _3: 'Try it out',
  _4: 'Making vehicles smart & healthy is good for your customers’ health and experience, but is also a potential boost for your revenue & innovative character! Try it out now!'
};

export const Categories = {
  _1: {
    title: "Automobile air conditioning",
    subcategories: [
      {
        key: 0,
        subtitle: 'How is the air the A/C pulls from outside?',
        text: 'There are two general options in automobile air conditioning (also called A/C) systems: one for recirculating air inside of the car and another for pulling outside air into your car\'s cabin. Many recent models have automatic systems with sensors that monitor in-cabin moisture and oxygen levels, switching between the recirculating and fresh air modes for you. But is the air the A/C pulls from outside healthy?'
      },
      {
        key: 1,
        subtitle: 'Cars are often driven in the worst areas of air pollution',
        text: 'Moreover, the AQ filters in the car are mostly not capable of purifying the incoming air sufficiently. Pollutant levels are often higher (up to 10 times!) inside a car, because it takes in emissions from surrounding vehicles and recirculates them.'
      }
    ]
  },
  _2: {
    title: 'The aircheckr solution',
    subcategories: [
      {
        key: 0,
        subtitle: 'Air quality varies a lot from place to place',
        text: 'The air can differ drastically when driving on a small rural road compared to standing still in a traffic jam or a tunnel. Stopping at red lights e.g. in urban and suburban areas greatly increases the exposure to air pollution in cars, according to Goel & Kumar (2015).'
      },
      {
        key: 1,
        subtitle: 'Outside air quality info to automate A/C',
        text: 'Developers can easily access the rich aircheckr database and integrate the real-time air quality data into the A/C system. While sensors inside indicate the air quality inside, aircheckr provides the data for the outside AQ. This way, the A/C could turn to the “recirculating air”-mode when outside air is bad and switch back, to the mode where outside air is pulled inside, in zones where the air quality is better.'
      }
    ]
  }
};

export const Quotes = [{
  key: 0,
  text: 'Levels of some pollutants and toxic compounds can be as much as 10 times higher inside vehicles than alongside the road.',
  author: 'Berkley Wellness, 2016'
},
{
  key: 1,
  text: 'Most filters in cars may help reduce allergy symptoms from pollens, for instance, but they are not effective in removing fine particulates or other pollutants.',
  author: 'Berkley Wellness, 2016'
}];

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/automotive_page.js